<template>
  <div class="container">
    <h1 class="title">
      Skritt's guide to Guild Wars 2 raids
    </h1>
    <div class="columns">
      <div class="column is-3">
        <b-menu :accordion="false" :activable="false">
          <b-menu-list label="General">
            <b-menu-item icon="information-outline" label="Summary"
                         tag="router-link"
                         :to="{name: 'raid-guide-index'}"
                         :active="$route.name === 'raid-guide-index'"
            />
          </b-menu-list>
          <b-menu-list label="Wing 1 (Spirit Vale)">
              <b-menu-item icon="circle-slice-3" label="Vale Guardian"
                           tag="router-link"
                           :to="{name: 'guide-vale-guardian'}"
                           :active="$route.name === 'guide-vale-guardian'"
              />
            <!--
              <b-menu-item icon="ghost" label="Gorseval"

                tag="router-link"
                :to="{name: 'guide-gorseval'}"
                :active="$route.name === 'guide-gorseval'"
              />
            -->
            <b-menu-item icon="timer-sand" label="Gorseval" disabled />
            <b-menu-item icon="timer-sand" label="Sabetha" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 2 (Salvation Pass)">
            <b-menu-item icon="timer-sand" label="Slothasor" disabled />
            <b-menu-item icon="timer-sand" label="Bandit Trio" disabled />
            <b-menu-item icon="timer-sand" label="Matthias" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 3 (Stronghold of the Faithful)">
            <b-menu-item icon="timer-sand" label="Escort" disabled />
            <b-menu-item icon="timer-sand" label="Keep Construct" disabled />
            <b-menu-item icon="timer-sand" label="Twisted Castle" disabled />
            <b-menu-item icon="timer-sand" label="Xera" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 4 (Bastion of the Penitent)">
            <b-menu-item icon="timer-sand" label="Cairn the Indomitable" disabled />
            <b-menu-item icon="timer-sand" label="Mursaat Overseer" disabled />
            <b-menu-item icon="timer-sand" label="Samarog" disabled />
            <b-menu-item icon="timer-sand" label="Deimos" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 5 (Hall of Chains)">
            <b-menu-item icon="timer-sand" label="Soulless Horror" disabled />
            <b-menu-item icon="timer-sand" label="River of Souls" disabled />
            <b-menu-item icon="timer-sand" label="Statues" disabled />
            <b-menu-item icon="timer-sand" label="Dhuum" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 6 (Mythwright Gambit)">
            <b-menu-item icon="timer-sand" label="Conjured Amalgamate" disabled />
            <b-menu-item icon="timer-sand" label="Twin Largos" disabled />
            <b-menu-item icon="timer-sand" label="Qadim" disabled />
          </b-menu-list>
          <b-menu-list label="Wing 7 (The Key of Ahdashim)">
            <b-menu-item icon="timer-sand" label="Cardinal Adina" disabled />
            <b-menu-item icon="timer-sand" label="Cardinal Sabir" disabled />
            <b-menu-item icon="timer-sand" label="Qadim the Peerless" disabled />
          </b-menu-list>
        </b-menu>
      </div>
      <div class="column">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RaidGuides",
  }
</script>

<style scoped>

</style>